import { useCallback } from 'react'
import { ProcessCellForExportParams, GridApi } from 'ag-grid-community'
import { exportExcel } from '../../../containers/BulkSheet/excel'
import { ProfitLossMemberRow } from '../ProfitLossMembers'

export const useExportExcel = (gridApi: GridApi): (() => void) => {
  const customExportValues = useCallback(
    (params: ProcessCellForExportParams): string | undefined => {
      if (!params.node || params.node.rowIndex === null) return undefined

      const row: ProfitLossMemberRow = params?.node?.data
      const colId: string = params.column.getColId()
      if (colId === 'body.generalLedger') {
        if (!row?.body?.type) {
          return row?.body?.generalLedger?.displayName
        }
      } else if (colId === 'body.subsidiary') {
        if (!row?.body?.type) {
          return row?.body?.subsidiary?.displayName
        }
      } else if (colId === 'body.financialState') {
        if (!row?.body?.type) {
          return row?.body?.financialState?.displayName
        }
      }
      return undefined
    },
    []
  )

  const onExportExcel = useCallback(() => {
    const colIds = gridApi?.getColumns() ?? []
    if (!colIds || colIds.length === 0) return
    exportExcel({
      fileNamePrefix: 'profit_loss_members',
      gridApi,
      exportColIds: colIds.map(v => v.getColId()),
      getCustomExportValue: customExportValues,
    })
  }, [gridApi, customExportValues])

  return onExportExcel
}
